import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";
import { ItemProcessingSource } from "./item-processing-source";

export const getItemProcessingSourceRequirement = {
  name: "getItemProcessingSourceRequirement" as const,
  input: z.object({
    source: ItemProcessingSource,
    locationId: locationIdFormat.schema,
  }),
  output: z.object({ required: z.boolean() }),
};
